import axios from 'axios'
import { BLOQUEAR_VENDA_USUARIO_EMPRESA_ITINERARIO_EM_LOTE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function bloquerUsuarioEmpresaItinerarioEmLote (parametros) {
  const url = `${URL}/itinerario/bloquear-venda-usuario-empresa-itinerario-em-lote`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BLOQUEAR_VENDA_USUARIO_EMPRESA_ITINERARIO_EM_LOTE,
        payload: response
      })
  );
}
